// extracted by css-extract-rspack-plugin
export default {"commonRowRegular":"W3VIWcf0","disabled":"lTZQw_6M","rowContent":"Xmuq3DfL","subtitleRow":"URE2VxKU","highlightedTitle":"HntD5VQS"};